/**
 * 配置编译环境和线上环境之间的切换
 *
 * baseUrl: 域名地址
 * routerMode: 路由模式
 *
 */

let baseUrl = '';
let routerMode = 'hash';
const protocol = window.location.protocol;	// url协议

if (process.env.NODE_ENV == 'development') {
	baseUrl = protocol + '//cs.yunyc.cn/gapservice'; // 测试
  // baseUrl = protocol + '//gap.yunyc.cn/gapservice'; // 测试

}else if(process.env.NODE_ENV == 'production'){
	baseUrl = protocol + '//cs.yunyc.cn/gapservice'; // 测试
  // baseUrl = protocol + '//gap.yunyc.cn/gapservice'; // 测试

}
export {
	baseUrl,
	routerMode
}



// WEBPACK FOOTER //
// ./src/config/env.js